import { IMessagingService } from "../services";
import { Component } from "./component";

class TitleComponent extends Component {
    constructor(componentEl: HTMLElement, messagingService: IMessagingService) {
        super(componentEl, messagingService);
    }
}

export { TitleComponent };